import logo from "./logo.svg";
import theme from "./theme";
import "./App.css";
import { Button } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Content from "./Components/Layouts/Content";
import RoutePage from "./Routes";
import { useEffect } from "react";
import { logout, reloadPage } from "./store/Slice/authSlice";
import { useDispatch } from "react-redux";
import authService from "./Services/auth.service";
import { TOKEN_EXP } from "./Config";
import moment from "moment";
import { webDetail } from "./store/Slice/settingSlice";
import { useLocation } from "react-router-dom";
import { Authen } from "./Services/Middleware/authen";

function App() {
  const user = authService.auth();
  const dispatch = useDispatch();
  const isAuth = Authen();

  useEffect(() => {
    dispatch(reloadPage());
    dispatch(webDetail());
    if (!isAuth) {
      document.body.classList.add("login-background");
    } else {
      document.body.classList.remove("login-background");
    }
    // eslint-disable-next-line
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Content>
          <RoutePage />
        </Content>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
